import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').service('PaginationService', PaginationService);

    /** @ngInject */
    function PaginationService() {
        var paginationData = {
            currentPage: 1,
            pageSize: 10,
        };

        return {
            getter: function () {
                return paginationData;
            },
            setter: function (value) {
                paginationData = value;
            },
        };
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/partials/universal_scripts/partials/pagination/scripts/services/pagination.service.ts